module.exports = __webpack_public_path__ + "static/media/ic-history.21c566de.svg";